import { call, takeLatest } from 'redux-saga/effects';
import {
  fetchDiseases,
  fetchLocations,
  fetchPhases,
  fetchSponsors,
  fetchTherapeuticAreas,
} from '@api/inventory';
import {
  fetchInventory,
  fetchInventoryFailure,
  fetchInventorySuccess,
} from './inventory.slice';
import { Resp, dispatch } from '../helpers';

const fetchAll = async () => {
  const response = await Promise.allSettled([
    fetchSponsors(),
    fetchTherapeuticAreas(),
    fetchPhases(),
    fetchDiseases(),
    fetchLocations(),
  ]);
  const [sponsors, therapeuticAreas, phases, diseases, locations] =
    response.map(promiseResult => {
      if (promiseResult.status === 'fulfilled') {
        return promiseResult.value.data.sort((a, b) =>
          a.name.localeCompare(b.name)
        );
      }
      return [];
    });
  return { sponsors, therapeuticAreas, phases, diseases, locations };
};

export function* inventoryWorker() {
  try {
    const inventory: Resp<typeof fetchAll> = yield call(fetchAll);
    yield dispatch(fetchInventorySuccess(inventory));
  } catch (error) {
    yield dispatch(fetchInventoryFailure(error as Error));
  }
}

export function* inventorySaga() {
  yield takeLatest(fetchInventory.type, inventoryWorker);
}
